// LogoutUser.js
import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from './UserContext';

function LogoutUser() {
  const navigate = useNavigate();

  const { setUser } = useContext(UserContext); // Access the context setter

  useEffect(() => {
    // Remove the authentication token from localStorage
    localStorage.removeItem('token');
    setUser(null); // Clear user data from context
    // Redirect to the login page
    navigate('/login');
    window.location.reload(); // Reload the page to re-evaluate the authentication state
  }, [navigate]);

  return null; // No UI needed, it just performs the logout
}

export default LogoutUser;